import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=14f24b57&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./activity.vue?vue&type=style&index=1&id=14f24b57&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f24b57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f24b57')) {
      api.createRecord('14f24b57', component.options)
    } else {
      api.reload('14f24b57', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=14f24b57&scoped=true", function () {
      api.rerender('14f24b57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/superSubsidyV2/activity.vue"
export default component.exports